module.exports = __webpack_public_path__ + "static/media/1.03bd8dd9.png";